import styled from '@emotion/styled';

import { COLOR_BORDER_SUBTLE, COLOR_SURFACE_TOOLBAR } from './utils/variables';

export const FormFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid ${COLOR_BORDER_SUBTLE};
  background: ${COLOR_SURFACE_TOOLBAR};
`;
